import { SITE } from "../lib/site";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="bg-[#0B0F0E]">
      <section className="max-w-3xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-12">
        <div className="overline"><span className="h-line" />Legal</div>
        <h1 className="font-display text-[#F4EFE6] text-5xl md:text-6xl mt-7 leading-[0.95]">
          Privacy &amp; <span className="italic-gold">data protection.</span>
        </h1>
        <p className="text-[#9BA39B] text-sm mt-4">Last updated: {new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</p>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-12 pb-28 space-y-10 text-[#E8E1D2] leading-relaxed">
        <div>
          <h2 className="font-display text-3xl text-[#F4EFE6]">Who we are</h2>
          <p className="mt-4">
            {SITE.name} (&quot;we&quot;, &quot;our&quot;, &quot;us&quot;) is a company registered in {SITE.jurisdiction} (Company No. <strong>{SITE.companyNumber}</strong>),
            with its registered office at {SITE.address}. We are the data controller responsible for the personal data described in this notice.
          </p>
          <p className="mt-3">Contact: <a className="text-[#C9A24B] hover:underline" href={`mailto:${SITE.email}`}>{SITE.email}</a> · {SITE.phone}</p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-[#F4EFE6]">What data we collect</h2>
          <ul className="mt-4 space-y-2 list-disc pl-6">
            <li><strong>Contact details</strong> you submit via our forms (name, email, phone, postal address).</li>
            <li><strong>Land details</strong> you choose to share (location, acreage, planning context, notes).</li>
            <li><strong>Letter response data</strong> if you respond to one of our postal mailings (reference code, interest level).</li>
            <li><strong>Technical data</strong> from your browser (IP, basic analytics) for security and traffic measurement.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-3xl text-[#F4EFE6]">Why we use it</h2>
          <ul className="mt-4 space-y-2 list-disc pl-6">
            <li>To respond to your enquiry and provide a confidential land appraisal.</li>
            <li>To manage any agreement we enter into with you.</li>
            <li>For our legitimate interest in promoting strategic land opportunities to landowners in regions we are active in (UK direct-mail, lawful basis: legitimate interest under UK GDPR Art. 6(1)(f)).</li>
            <li>To comply with our legal obligations (Companies Act, anti-money-laundering, etc.).</li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-3xl text-[#F4EFE6]">How long we keep it</h2>
          <p className="mt-4">
            Enquiry data: 7 years from last contact. Suppression records: indefinitely (so we do not re-contact you). Contract data: 7 years from end of agreement, as required by HMRC.
          </p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-[#F4EFE6]">Your rights</h2>
          <p className="mt-4">
            Under UK GDPR you have the right to access, correct, delete, restrict, port or object to our use of your personal data. To exercise any right, email <a className="text-[#C9A24B] hover:underline" href={`mailto:${SITE.email}`}>{SITE.email}</a>. You also have the right to complain to the <a className="text-[#C9A24B] hover:underline" href="https://ico.org.uk/make-a-complaint/" target="_blank" rel="noreferrer">Information Commissioner&apos;s Office</a>.
          </p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-[#F4EFE6]">Direct marketing &amp; suppression</h2>
          <p className="mt-4">
            If you received a letter from us and do not wish to receive further mailings, visit our <Link to="/unsubscribe" className="text-[#C9A24B] hover:underline" data-testid="privacy-unsubscribe-link">unsubscribe page</Link> or email us at {SITE.email}. We will add your address to our permanent suppression list within five working days.
          </p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-[#F4EFE6]">Cookies &amp; analytics</h2>
          <p className="mt-4">
            This website uses only essential cookies required for the site to function. We do not currently use third-party advertising cookies.
          </p>
        </div>

        <div className="border-t border-[#F4EFE6]/10 pt-8 text-sm text-[#9BA39B]">
          {SITE.name} · Company No. {SITE.companyNumber} · Registered in {SITE.jurisdiction} · {SITE.address}
        </div>
      </section>
    </div>
  );
}
